import { takeLatest, select, call, put } from 'redux-saga/effects';
import * as types from '../constants/actionTypes';
import * as proxy from '../api/mychartProxyAPI';
import * as common from './commonSaga';

export default function* mychartProxySaga() {
    yield takeLatest(types.MYCHART_PROXY_REQUEST, handle, proxy.requestAccess, 'MBHWeb.Saga.MyChart.Proxy.RequestProxyAccess');
}

function* handle(apiCall, andyliticsLogName, action) {
    try {
        const domainData = yield select((state) => state.domain);
        if (action.success && !action.error) {
            yield call(common.handle, apiCall, domainData.t, andyliticsLogName, action);
        }
    }
    catch (e) {
        console.error(e);
    }
}